import { useState } from "react";
import { acceptGroupInvite, dismissGroupInvite } from "../../services/firebase";
import { Dialog, CircularProgress } from "@mui/material";
import CloseIcon from "../../assets/icons/cross-solid";

export interface NotificationType {
  id: string;
  senderName: string;
  groupId: string;
}

interface NotificationsPopupProps {
  userId: string;
  notifications: NotificationType[];
  setNotifications: React.Dispatch<React.SetStateAction<NotificationType[]>>;
  showPopup: boolean;
  setShowPopup: (value: boolean) => void;
}

const NotificationsPopup: React.FC<NotificationsPopupProps> = ({
  userId,
  notifications,
  setNotifications,
  showPopup,
  setShowPopup,
}) => {
  const [loading, setLoading] = useState(false);
  //   const [showPopup, setShowPopup] = useState(false);
  const [processingId, setProcessingId] = useState<string | null>(null);

  //   useEffect(() => {
  //     const loadNotifications = async () => {
  //       try {
  //         setLoading(true);
  //         const invites = await fetchNotifications(userId);
  //         console.log("invites: ", invites);
  //         setNotifications(invites);
  //       } catch (error) {
  //         console.error("Error fetching notifications:", error);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };

  //     loadNotifications();
  //   }, [userId]);

  const handleAccept = async (invite: NotificationType) => {
    setProcessingId(invite.id);
    try {
      await acceptGroupInvite(invite.id, userId);
      setNotifications((prev: NotificationType[]) =>
        prev.filter((n: NotificationType) => n.id !== invite.id)
      ); // ✅ Explicit type
    } catch (error) {
      console.error("Error accepting invite:", error);
    } finally {
      setProcessingId(null);
    }
  };

  const handleDismiss = async (inviteId: string) => {
    try {
      await dismissGroupInvite(inviteId);
      setNotifications((prev: NotificationType[]) =>
        prev.filter((n: NotificationType) => n.id !== inviteId)
      ); // ✅ Explicit type
    } catch (error) {
      console.error("Error dismissing invite:", error);
    }
  };

  return (
    <>
      {/* <Badge
        badgeContent={notifications.length}
        color="error"
        onClick={() => setShowPopup(true)}
        className="cursor-pointer"
      >
        <NotificationIcon size={28} color="#3A9437" />
      </Badge> */}

      <Dialog
        open={showPopup}
        onClose={() => setShowPopup(false)}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "36px",
            backgroundColor: "#efedf4",
          },
        }}
      >
        <div className="p-6 pb-10 ">
          {/* Header */}
          <div className="flex items-center justify-between  mb-4">
            <h2 className="font-grgrifter tracking-wider text-[1.5em]  text-[#afaeb3]">
              Group Invitations
            </h2>
            <button
              onClick={() => setShowPopup(false)}
              className="p-2 rounded-[0.9em] bg-[#CEE4CD]"
            >
              <CloseIcon color="#3A9437" size={20} />
            </button>
          </div>

          <div className="flex flex-col h-[26em] w-[70vw] md:max-w-[33em] overflow-y-auto">
            {notifications.length === 0 ? (
              <p className="text-gray-500">No new invitations</p>
            ) : (
              notifications.map((invite) => (
                <div
                  key={invite.id}
                  className="flex flex-col justify-center items-left mb-3 py-4 border rounded-2xl  bg-white px-4"
                >
                  <p className="text-[#1B1B1B] text-[1em] ">
                    {invite.senderName.split(" ")[0]} invited you
                  </p>
                  <div className="w-full flex gap-5 mt-2">
                    <button
                      className="bg-[#3A9437] text-white py-1 px-4 rounded-2xl text-[0.7em]"
                      onClick={() => handleAccept(invite)}
                      disabled={processingId === invite.id}
                    >
                      {processingId === invite.id ? (
                        <CircularProgress size={18} color="inherit" />
                      ) : (
                        "Accept"
                      )}
                    </button>
                    <button
                      className="text-[#3a9437] p-1 rounded-2xl text-[0.7em]"
                      onClick={() => handleDismiss(invite.id)}
                    >
                      Dismiss
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default NotificationsPopup;
